export const environment = {
    production: false,
    baseUrl: "https://api.authoringtool.bridg-ou.com",
    // baseUrl: "https://test.api.authoringtool.bridg-ou.com",
    ASAPAbaseUrl: "https://sunrise.pasiphae.eu/sunrise/asapa",
    // firebaseConfig : {
    //     apiKey: "AIzaSyBVARpofcyAya0Pj9tAevJsR1faRgRi-Zo",
    //     authDomain: "sunrise-authoring-tool.firebaseapp.com",
    //     projectId: "sunrise-authoring-tool",
    //     storageBucket: "sunrise-authoring-tool.appspot.com",
    //     messagingSenderId: "615916821905",
    //     appId: "1:615916821905:web:aea91690909ddee7604e30",
    //     measurementId: "G-6203LHNMPX",
    //     vapidKey: "BOKsAe_aP4WcIvEVTxgleOeDImshx0Op2QjsHCeGTXcBn-pdkcexT_skMPy3rQk7EvQ0QQqZUrp3TNzlPTSvAxA"
    //   }

};